<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <h5>Asistente para el registro de Citas</h5>

    <div style="display:flex; justify-content:space-between; align-items:center;
                background-color:#f0f0f0; padding:10px; border-radius:5px;">
      <h4 class="mb-0">Paso 3: Resumen de la cita</h4>
      <span class="badge-tipo"
            :class="datoCita.tipoIngreso === 'Admisión' ? 'badge-tipo--admision' : 'badge-tipo--agendamiento'">
        {{ datoCita.tipoIngreso || 'Agendamiento' }}
      </span>
    </div>

    <hr>

    <!-- Estado de carga -->
    <div v-if="cargando" class="text-center py-5 text-muted">
      <span class="material-symbols-outlined" style="font-size:40px;">hourglass_top</span>
      <p class="mt-2">Cargando resumen...</p>
    </div>

    <!-- Resumen -->
    <div v-else class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">

          <!-- Cabecera de éxito -->
          <div class="resumen-exito mb-4">
            <span class="material-symbols-outlined resumen-exito__icono">check_circle</span>
            <div>
              <p class="resumen-exito__titulo">Cita registrada exitosamente</p>
              <p class="resumen-exito__subtitulo">
                Cita N° <strong>{{ datoCita.numero }}</strong> —
                {{ getFormattedDate(datoCita.fechaCita) }},
                {{ datoCita.horaDesde }} a {{ datoCita.horaHasta }}
              </p>
            </div>
          </div>

          <!-- Grilla de campos -->
          <div class="resumen-grid">

            <div class="resumen-campo" v-for="campo in camposResumen" :key="campo.label">
              <span class="resumen-campo__label">{{ campo.label }}</span>
              <span class="resumen-campo__valor">{{ campo.valor || '—' }}</span>
            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-2">

            <!-- Grupo izquierdo -->
            <div class="d-flex gap-2 flex-wrap">
              <button type="button" class="btn btn-primary d-flex align-items-center gap-1"
                      @click="irACitas" title="Ver lista de agendamiento y admisión">
                <i class="material-icons" style="font-size:20px;">event</i>
                Agendamiento y Admisión
              </button>
              <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-1"
                      @click="irAAtenciones" title="Ver lista de atenciones">
                <i class="material-icons" style="font-size:20px;">list_alt</i>
                Atenciones
              </button>
              <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-1"
                      @click="nuevaCita" title="Registrar otra cita">
                <i class="material-icons" style="font-size:20px;">add_circle</i>
                Nueva cita
              </button>
            </div>

            <!-- Volver a atención (solo si viene desde una atención) -->
            <button type="button" class="btn btn-success d-flex align-items-center gap-1"
                    @click="irAtencionSeleccionada"
                    v-if="Number(p_idAtencion) > 0"
                    title="Volver a la atención">
              <i class="material-icons" style="font-size:20px;">check_circle</i>
              Volver a la Atención
            </button>

          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'

export default {
  name: 'PacienteCita03',
  components: { Layout, Footer },

  data() {
    return {
      datoCita:     {},
      cargando:     true,
      p_idCita:     0,
      p_idAtencion: 0,
    }
  },

  computed: {
    camposResumen() {
      return [
        { label: 'Número de cita',   valor: this.datoCita.numero },
        { label: 'Tipo de ingreso',  valor: this.datoCita.tipoIngreso },
        { label: 'Paciente',         valor: this.datoCita.nombrePaciente },
        { label: 'Especialidad',     valor: this.datoCita.nombreEspecialidad },
        { label: 'Médico',           valor: this.datoCita.nombreMedico },
        { label: 'Fecha',            valor: this.getFormattedDate(this.datoCita.fechaCita) },
        { label: 'Hora desde',       valor: this.datoCita.horaDesde },
        { label: 'Hora hasta',       valor: this.datoCita.horaHasta },
        { label: 'Motivo',           valor: this.datoCita.nombreMotivoCita },
        { label: 'Descripción',      valor: this.datoCita.descripcion },
      ]
    },
  },

  mounted() {
    this.p_idCita     = this.$route.params.p_idcita
    this.p_idAtencion = window.sessionStorage.getItem('idAtencion') ?? 0

    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()

    this.fetchCita()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    fetchCita() {
      this.cargando = true
      api.get('/vwcitas/' + this.p_idCita)
        .then(response  => { this.datoCita = response.data })
        .catch(error    => console.error('Error al obtener la cita:', error))
        .finally(()     => { this.cargando = false })
    },

    irACitas() {
      this.$router.push('/cita')
    },

    irAAtenciones() {
      this.$router.push('/atencion')
    },

    nuevaCita() {
      this.$router.push('/pacientecita01/0')
    },

    irAtencionSeleccionada() {
      this.$router.push('/atencionform/' + this.p_idAtencion)
    },
  },
}
</script>

<style src="@/assets/css/wizardResumen.css" scoped></style>

<style scoped>
/* Cabecera de éxito */
.resumen-exito {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #eafaf1;
  border: 1px solid #a9dfbf;
  border-radius: 8px;
  padding: 14px 18px;
}
.resumen-exito__icono {
  font-size: 36px;
  color: #27ae60;
  flex-shrink: 0;
}
.resumen-exito__titulo {
  font-weight: 600;
  font-size: 1rem;
  color: #1e8449;
  margin: 0;
}
.resumen-exito__subtitulo {
  font-size: 0.88rem;
  color: #555;
  margin: 2px 0 0;
}

/* Grilla de campos del resumen */
.resumen-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
}
.resumen-campo {
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  border-bottom: 1px solid #e9ecef;
}
.resumen-campo:nth-child(odd) {
  border-right: 1px solid #e9ecef;
}
.resumen-campo__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}
.resumen-campo__valor {
  font-size: 0.95rem;
  color: #212529;
  text-transform: uppercase;
}

/* Badges tipo ingreso */
.badge-tipo {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.82rem;
  font-weight: 600;
}
.badge-tipo--agendamiento { background-color: #a2cf6e; color: #1a3d00; }
.badge-tipo--admision     { background-color: #f7d08a; color: #5a3e00; }

@media (max-width: 576px) {
  .resumen-grid {
    grid-template-columns: 1fr;
  }
  .resumen-campo:nth-child(odd) {
    border-right: none;
  }
}
</style>